import { Box, IconButton, TextField } from "@mui/material";
import "./CardShoppingCart.css";
import CloseIcon from "@mui/icons-material/Close";
import React, { useState } from "react";
import { deleteProductFromOrder } from "../../../services/posOrders";
import { Refresh } from "@mui/icons-material";

const CardShoppingCart = (props) => {
  const product = props.productData;
  const { orderId, index, onRemoveProduct } = props; // Recibir el orderId y el índice

  const [quantity, setQuantity] = useState(parseInt(product.quantity));
  const [notification, setNotification] = useState(""); // Estado para la notificación
  const handleChangeQuantity = (event) => {
    if (event.target.value < 1) {
      setQuantity(1);
    } else {
      if (event.target.value <= maxQuantity) {
        setQuantity(event.target.value);
      }
    }
  };

  const total = parseInt(product.price);
  const maxQuantity = parseInt(product.maxQuantity);

  const handleRemoveClick = () => {
    // Llamar a la función de eliminación
    deleteProductFromOrder(parseInt(orderId), parseInt(product.ref))
      .then(() => {
        // Si la eliminación fue exitosa, mostrar mensaje de confirmación
        alert("Producto eliminado con éxito.");
        window.location.reload();

        if (onRemoveProduct) {
          onRemoveProduct(orderId, parseInt(product.ref)); // Llamar a onRemoveProduct si se pasa como prop
        }
      })
      .catch(() => {
        // Si hubo un error, mostrar mensaje de error
        console.log(parseInt(orderId), parseInt(product.ref));
        console.log(product);
        setNotification("Error al eliminar el producto.");

        // Ocultar la notificación después de 3 segundos
        setTimeout(() => setNotification(""), 3000);
      });
  };

  return (
    <Box className="card-container-box">
      <div className="product-pic-wrap-card">
        <img src={product.src} className="product-pic-card" />
      </div>
      <div className="product-info-block">
        <div className="product-info-header">
          <div className="product-name-shopping-cart">{product.name}</div>
          <div className="boton-cancelar">
            <IconButton onClick={handleRemoveClick}>
              <CloseIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </div>
        </div>
        <div className="shopping-controls-block">
          <div>
            <div style={{ float: "left", marginTop: "7px" }}>
              Precio Total: ₡{total}
            </div>
            <div
              style={{
                display: "flex",
                float: "right",
                marginRight: "10px",
                flexFlow: "column",
              }}
            >
              <div style={{ flexFlow: "row" }}>
                <TextField
                  id="outlined-number"
                  type="number"
                  size="small"
                  value={quantity}
                  label="Unidades"
                  onChange={handleChangeQuantity}
                  sx={{
                    fontSize: "12px",
                    width: "105px",
                    marginBottom: "5px",
                  }}
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                  InputProps={{
                    style: { fontSize: "13px" },
                  }}
                />
              </div>
              <div style={{ fontSize: "10px", fontWeight: "bold" }}>
                Precio unitario: ₡{product.price / product.quantity}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
};

export default CardShoppingCart;
